import React from "react";
import PropTypes from "prop-types";
import { Accordion } from "react-bootstrap-accordion";
// import router link
import { Link, withRouter } from "react-router-dom";
import { Rate } from "antd";
// import store, actions
import { connect } from "react-redux";
import {
  setAppTokenAsked,
  setAppTokenRetrieved,
  setSchool,
  togglePreloader,
} from "../../store/actions";

// import deep-equal
import equal from "deep-equal";
// import moment
import moment from "moment";
import "moment/locale/fr";
// import flag
import Flag from "react-flagkit";
// import dummies
import {
  COUNTRY,
  FAQS,
  FOREIGNS,
  OPPORTUNITY,
  SCHOOL,
} from "../../helpers/dummies";

// import services
import {
  getOtherSchool,
  getSchool,
  getSchools,
  getSchoolFormationFilter,
  getSchoolFormationFilterResult,
} from "../../services/schoolService";
import { addComment } from "../../services/commentService";
import { addFaq } from "../../services/faqService";

// import common components
import Carousels from "../../components/common/Carousels";
import Banner from "../../components/common/Banner";
import Leading from "../../components/common/Leading";
import Breadcrumbs from "../../components/common/Breadcrumbs";
import Square from "../../components/common/Square";
import Mailer from "../../components/common/Mailer";
import Maper from "../../components/common/Maper";
import Commenter from "../../components/common/Commenter";
import Sliders, { RESPONSIVES } from "../../components/common/Sliders";
import Questioner from "../../components/common/Questioner";
import SocialShare from "../../components/common/SocialShare";

// import custom components
import ListFormation from "../../components/custom/formations/ListFormation";

// import constants
import {
  APP_TOKEN,
  SCHOOL_ACCORDIONS,
  UNKNOWN_ERROR,
  USER_DATA,
  SLIDERS,
} from "../../helpers/constants";

// import utilities
import {
  formatArrayToString,
  formatFaqsForDisplay,
  isNotEmptyArray,
  isUnauthenticatedRequest,
  slugify,
} from "../../helpers/utilities";

// import icons
import {
  icClassesRhythm,
  icDate,
  icDeliveryMode,
  icLanguage,
  icRank,
  icScholarship,
  mkSchool,
  icRightArrow,
} from "../../assets/images";

import CommonIcon from "../../components/common/CommonIcon";
import vector from "../../assets/images/university/Vector.png";
import Formation from "../../components/common/Formation";
import Frame from "../../components/common/UniBanner";
import rectangle27 from "../../assets/images/university/rectangle-27.png";
import face from "../../assets/images/university/face.png";
import twitter from "../../assets/images/university/twitter.png";
import youtube from "../../assets/images/university/youtube.png";
import insta from "../../assets/images/university/insta.png";
import whatsapp from "../../assets/images/university/whats.png";
import tick from "../../assets/images/university/tick.png";
import icon1 from "../../assets/images/university/icon1.png";
import icon2 from "../../assets/images/university/icon2.png";
import icon3 from "../../assets/images/university/icon3.png";
import icon4 from "../../assets/images/university/icon4.png";
import share from "../../assets/images/university/share.png";
import like from "../../assets/images/university/like.png";
import togo from "../../assets/images/university/togo.png";
import date from "../../assets/images/university/date.png";
import clock from "../../assets/images/university/clock.png";
import person from "../../assets/images/university/person.png";
import lang from "../../assets/images/university/lang.png";
import uniogo from "../../assets/images/university/unilogo.png";
import background from "../../assets/images/university/background.png";
import frame from "../../assets/images/university/Frame.jpg";
import logo from "../../assets/images/university/degreeExample.png";
import schoolBackgorund from "../../assets/images/bilding.jpg";
import StarImage from "../../assets/images/start.svg";

// custom sliders options
const SLIDERS_RESPONSIVES = {
  ...RESPONSIVES,
  desktop: { ...RESPONSIVES.desktop, items: 3 },
  tablet: { ...RESPONSIVES.tablet, items: 2 },
};

class School extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      commenter: { loading: false, failure: "", success: false },
      mailer: { loading: false, failure: "", success: false },
      questioned: { loading: false, failure: "", success: false },
      showSubsriptionLink: false,
      showCommentSection: false,
      showSocialShare: false,
      allOpportunities: [],
      formations: [],
      zIndex: "-1",
      otherSchools: [],
      formationFilter: [],
      filteredResults: { coordinates: { lat: "", lng: "" } },
      isShareModalOpen: false,
      // setIsShareModalOpen:false,
    };
  }

  componentDidMount() {
    try {
      console.log("compoenent Did mount is Called");
      //Get props
      let { onPreloaderToggled, location } = this.props;
      console.log("location", location)
      if (!location.state.isPublic && !localStorage.getItem(USER_DATA)) {
        //Check school status
        console.log("conding the trust")
        this.setState({ showSubsriptionLink: true });
        this.onGetSchool();
        this.onGetOtherScool();
      }
      else {
        //Start preloader
        onPreloaderToggled(true, "Chargement de l'établissement");

        // Load school
        this.onGetSchool();
        this.onGetOtherScool();
      }
    } catch (error) {
      console.error(error);
    }
  }

  componentDidUpdate(prevProps) {
    try {
      //Check props
      if (!equal(prevProps, this.props)) {
        //Get props
        this.loadData();
        let { tokenRetrieved, tokenFailed, onPreloaderToggled } = this.props;

        //Check app token retrieved
        if (tokenRetrieved && localStorage.getItem(APP_TOKEN))
          this.continueWithRetrievedToken();
        //Stop preload
        else if (tokenFailed) onPreloaderToggled(false, "");
      }
    } catch (error) {
      console.error(error);
    }
  }

  //load data on

  loadData() {
    try {
      // Get props
      let { onPreloaderToggled, location } = this.props;

      if (!location.state.isPublic && !localStorage.getItem(USER_DATA)) {
        // Check school status
        this.setState({ showSubsriptionLink: true });
        this.onGetSchool();
        // this.onGetOtherSchool();
      } else {
        // Start preloader
        onPreloaderToggled(true, "Chargement de l'établissement");

        // Load school
        this.onGetSchool();
        // this.onGetOtherSchool();
      }
    } catch (error) {
      console.error(error);
    }
  }

  componentWillUnmount() {
    try {
      this.props.onSetSchool({});
      this.props.onSetSchool([]);
    } catch (error) {
      console.error(error);
    }
  }

  /**
   * Toggle form modal.
   *
   * @param {*} option
   */
  onModalToggled = (option = "showSocialShare", visible = false) => {
    this.setState({ [option]: visible });
  };

  /**
   * On comment section showed.
   *
   */
  onCommentSectionShowed = () => {
    this.setState((prevState) => ({
      showCommentSection: !prevState.showCommentSection,
    }));
  };

  /**
   * Continue with retrieved token.
   *
   */
  continueWithRetrievedToken() {
    try {
      let { schools, school } = this.props;
      console.log({ schools, school });
      if (!(school && school.id && school.publicId)) {
        this.onGetSchool();
        this.onGetOtherScool();
      } else if (!isNotEmptyArray(schools)) {
        this.onGetSchools();
        this.onGetOtherScool();
      }
    } catch (error) {
      console.error(error);
    }
  }

  /**
   * On get school.
   *
   */
  onGetSchool() {
    
    let { onSetSchool, onPreloaderToggled, onAppTokenAsked, location } =
      this.props;
    let { code } = location.state;
    console.log("code", { code });
    getSchool(code)
      .then((response) => {
        if (response && response.publicId && response.publicId === code) {
          let {
            logo,
            photos,
            city,
            address,
            country,
            language,
            formationRhythm,
            teachingMode,
            latitude,
            longitude,
            formations,
          } = response;
          console.log("onset", formations);
          onSetSchool({
            ...response,
            logo: logo ? logo : SCHOOL.image,
            photos: isNotEmptyArray(photos) ? photos : SCHOOL.sliders,
            city: city ? city : COUNTRY.city,
            address: address ? address : COUNTRY.address,
            // country: country ? country : COUNTRY,
            language: JSON.parse(language),
            // language: JSON.parse('"' + language.replace(/"/g, '\\"') + '"'),
            formationRhythm: JSON.parse(formationRhythm),
            teachingMode: JSON.parse(teachingMode),
            coordinates: {
              lat:
                latitude != null && latitude !== ""
                  ? latitude
                  : OPPORTUNITY.coordinates.lat,
              lng:
                longitude != null && longitude !== ""
                  ? longitude
                  : OPPORTUNITY.coordinates.lng,
            },
            formations: formations ? formations : [],
            showSocials: this.canDisplaySocialsNetworks(response),
          });

          //Load similars schools
          this.onGetSchools();
        } else if (isUnauthenticatedRequest(response)) {
          onAppTokenAsked();
        } else {
          onPreloaderToggled(false, "");
          console.error(response, "GET SCHOOL ERROR");
        }
      })
      .catch((error) => {
        onPreloaderToggled(false, "");
        console.error(error.message, "GET SCHOOL ERROR");
      });
    getSchoolFormationFilter(code)
      .then((res) => {
        console.log("filter======", res);
        const { formationFilter, formation } = res;
        if (formationFilter.length > 0 && formation.length > 0) {
          this.setState({
            formationFilter: formationFilter ? formationFilter : [],
            formations: formation ? formation : [],
          });
        } else {
          this.setState({
            formationFilter: formationFilter ? formationFilter : [],
            formations: formation ? formation : [],
          });
        }
      })
      .catch((err) => {
        if (err) {
          console.log(err);
        }
      });
  }

  // formation filter

  onGetOtherScool() {
    let data = {
      longitude: "106.48686",
      latitude: "66.726197",
    };
    getOtherSchool(data)
      .then((res) => {
        console.log("response", res);
        if (res) {
          this.setState({
            otherSchools: res ? res : [],
          });
        } else {
          this.setState({
            otherSchools: [],
          });
        }
      })
      .catch((err) => {
        this.setState({
          otherSchools: err ? [] : [],
        });
      });
  }

  handleTabClick(e) {
    let { location } = this.props;
    let { code } = location.state;
    let data = {
      code: code,
      filterName: e,
    };
    getSchoolFormationFilterResult(data)
      .then((res) => {
        // console.log("filter======",res)
        const { formationFilter, formation } = res;
        if (formationFilter.length > 0 && formation.length > 0) {
          this.setState({
            formationFilter: formationFilter ? formationFilter : [],
            formations: formation ? formation : [],
          });
        } else {
          this.setState({
            formationFilter: formationFilter ? formationFilter : [],
            formations: formation ? formation : [],
          });
        }
      })
      .catch((err) => {
        if (err) {
          console.log(err);
        }
      });
  }

  handleShareModalOpen = () => {
    this.setState({
      isShareModalOpen: true,
    });
  };

  handleShareModalClose = () => {
    this.setState({
      isShareModalOpen: false,
    });
  };

  /**
   * On Get Schools.
   *
   */
  onGetSchools = () => {
    let { onSetSchool, onPreloaderToggled, onAppTokenAsked } = this.props;

    getSchools()
      .then((response) => {
        if (isUnauthenticatedRequest(response)) {
          onAppTokenAsked();
        } else {
          if (response && response.data) onSetSchool(response.data);
          else console.error(response, "GET SCHOOLS ERROR");
          onPreloaderToggled(false, "");
        }
      })
      .catch((error) => {
        onPreloaderToggled(false, "");
        console.error(error, "GET SCHOOLS ERROR");
      });
  };

  /**
   * On Commented.
   *
   * @param {*} data
   */
  onCommented = (data) => {
    try {
      //Get props
      let { school } = this.props;

      //Start loader
      this.setState({
        commenter: { loading: true, failure: "", success: false },
      });

      //Launch save comment's request
      let comment_data = {
        content: data.comments,
        internationalOpening: data.internationalOpening,
        professionalPreparation: data.professionalPreparation,
        teachingQuality: data.teachingQuality,
        recommendSchool: data.recommendSchool,
        title: data.title,
        schoolId: school.id,
      };

      addComment(comment_data)
        .then((response) => {
          if (
            response.id &&
            response.school &&
            response.school.id &&
            response.school.id === school.id
          ) {
            this.setState({
              commenter: { loading: false, failure: "", success: true },
            });
          } else {
            console.error(response, "POST COMMENT ERROR");
            this.setState({
              commenter: {
                loading: false,
                failure: UNKNOWN_ERROR,
                success: false,
              },
            });
          }
        })
        .catch((error) => {
          console.error(error, "POST COMMENT ERROR");
          this.setState({
            commenter: {
              loading: false,
              failure: UNKNOWN_ERROR,
              success: false,
            },
          });
        });
    } catch (error) {
      console.error(error);
    }
  };

  /**
   * On Questioned.
   *
   * @param {*} data
   * @param {*} onCleared
   */
  onQuestioned = (data, onCleared) => {
    try {
      let { school } = this.props;
      let user = JSON.parse(localStorage.getItem(USER_DATA));

      this.setState({
        questioned: { loading: true, failure: "", success: false },
      });

      let faq_data = {
        userId: user.id,
        userDiploma: data.diplomas[0].label,
        question:
          data.faqs[0].question !== "Autres"
            ? data.faqs[0].question
            : data.otherQuestion,
        userProfile: data.profile,
        userEmail: data.useremail,
        countryId: data.residence[0].value,
        schoolId: school.id,
      };

      addFaq(faq_data)
        .then((response) => {
          if (
            response.id &&
            response.school &&
            response.school.id &&
            response.school.id === school.id
          ) {
            this.setState({
              commenter: { loading: false, failure: "", success: true },
            });
          } else {
            console.error(response, "POST FAQ ERROR");
            this.setState({
              commenter: {
                loading: false,
                failure: UNKNOWN_ERROR,
                success: false,
              },
            });
          }
        })
        .catch((error) => {
          console.error(error, "POST FAQ ERROR");
          this.setState({
            commenter: {
              loading: false,
              failure: UNKNOWN_ERROR,
              success: false,
            },
          });
        });
    } catch (error) {
      console.error(error);
    }
  };

  /**
   * On Mailed.
   *
   * @param {*} data
   * @param {*} onCleared
   */
  onMailed = (data, onCleared) => {
    try {
      this.setState({ mailer: { loading: true, failure: "", success: false } });
      setTimeout(() => {
        this.setState(
          {
            mailer: { loading: false, failure: "", success: true },
          },
          () => {
            onCleared();
          }
        );
      }, 2000);
    } catch (error) {
      console.error(error);
    }
  };

  /**
   * Can display socials  networks.
   *
   * @returns
   */
  canDisplaySocialsNetworks(item) {
    try {
      //Get school values from props
      let {
        facebookLink,
        instagramLink,
        youtubeLink,
        twitterLink,
        telegramLink,
      } = item;

      //Filter socials networks
      let atLeastSocial = [
        facebookLink,
        instagramLink,
        youtubeLink,
        twitterLink,
        telegramLink,
      ].find((item) => item !== null);

      //Return results
      return atLeastSocial !== null && atLeastSocial !== undefined;
    } catch (error) {
      console.error(error);
      return false;
    }
  }

  /**
   * Format Tops.
   *
   * @param {*} world
   * @param {*} africa
   * @param {*} top
   * @returns
   */

  formatTops(world, africa, top) {
    return world && africa
      ? `Top ${top} Afrique et monde`
      : world
        ? `Top ${top} monde`
        : africa
          ? `Top ${top} Afrique`
          : "Non renseigné";
  }

  onCreditReduced = () => {
    console.error("REDUCE USER/SCHOOL CREDITS");
  };

  onShared = () => {
    this.onCreditReduced();
    this.onModalToggled("showSocialShare", true);
  };

  onLiked = () => {
    console.error("ON LIKED");
    this.onCreditReduced();
  };

  handleOnClick = () => {
    console.log("Button clicked!");
  };

  render() {
    console.log("this.props.params", this.props);
    const { school, schools, isPreloader, location } = this.props;
    const {
      filteredResults,
      formationFilter,
      otherSchools,
      commenter,
      mailer,
      questioned,
      showSubsriptionLink,
      showCommentSection,
      showSocialShare,
      formations,
      isShareModalOpen,
    } = this.state;
    let { zIndex } = this.state;
    console.log("formationFilter", formationFilter);
    console.log("coordinates", school.coordinates);
    console.log({ schools });
    console.log("formation", formations);
    console.log("filter result", { filteredResults });

    return (
      <React.Fragment>
        <>
          {school && school.publicId ? (
            <>
              <div className="container p-16">
                {/* <Breadcrumbs
                  extratitle={`${school.country.name}`}
                  extratitleLink={`/pays/${school.country.publicId}`}
                  subtitle="Établissements"
                  subtitleLink="/etablissements"
                  currentTile={`${school.name}`}
                /> */}
                <div className="flex justify-between mb-3 mt-2">
                  <Breadcrumbs
                    extratitle="Ivory Coast"
                    extratitleLink="/"
                    subtitle="Établissements"
                    subtitleLink="/"
                    currentTile={school?.name}
                  />
                  <CommonIcon />
                </div>
                <section className="home-slider">
                  <Carousels
                    centerMode
                    infiniteLooped
                    items={school.photos}
                    carouselsClasses="banner-carousel"
                    itemKey="school_carousel_item"
                    withArrows={false}
                    withIndicators={false}
                    autoPlayed={true}
                  />
                </section>

                {school ? (
                  <section class="academie-banner">
                    <div class="academie-banner-section-div">
                      <div class="academie-banner-main-div">
                        <div class="academie-logo">
                          <img src={logo} alt="" />
                        </div>
                        <div class="academie-content">
                          <div class="academie-content-left">
                            <div class="top-block">
                              <div class="title">
                                <h2>{school?.name}</h2>
                              </div>
                              <div class="academie-content-right">
                                <div class="opportunit-icon-div">
                                  <div class="opportunit-icon-div-top">
                                    <span>Partager</span>
                                    <button
                                      type="button"
                                      onClick={this.handleShareModalOpen}
                                    >
                                      <a href="javascript:void(0);">
                                        <img src={share} alt="share icon" />
                                      </a>
                                    </button>

                                    <SocialShare
                                      opened={isShareModalOpen}
                                      onClosed={this.handleShareModalClose}
                                      shareLink={`https://dev.aceorientation.com/formations/${slugify(
                                        school?.name
                                      )}`}
                                    />
                                  </div>
                                  <div class="opportunit-icon-div-top">
                                    <span>Suivre</span>
                                    <a href="javascript:void(0);">
                                      <img src={like} alt="" />
                                    </a>
                                  </div>
                                </div>
                              </div>
                            </div>

                            <div class="flag-div">
                              <div class="top-title">
                                <p>
                                  <a href="#">Laisser un commentaire</a>
                                </p>
                                <p>
                                  {school?.country?.name}{" "}
                                  <span>
                                    {school?.country?.continent}
                                    <a href="">
                                      <img src={togo} alt="" />
                                    </a>
                                  </span>
                                </p>
                              </div>
                            </div>
                          </div>

                          <div class="academie-content-bottom">
                            <div class="academie-content-bottom-icon">
                              <p>Suivre:</p>
                              {school.facebookLink && school.facebookLink != "- "&& (
                                <a href={school.facebookLink} target="_blank">
                                  <img src={face} alt="" />
                                </a>
                              )}
                              {school.whatsappLink && school.whatsappLink != "- "&& (
                                <a href={school.whatsappLink} target="_blank">
                                  <img src={whatsapp} alt="" />
                                </a>
                              )}
                              {school.whatsappLink && school.instagramLink != "- "&& (
                                <a href={school.instagramLink} target="_blank">
                                  <img src={insta} alt="" />
                                </a>
                                )}
                              {school.twitterLink && school.twitterLink != "- "&& (
                                <a href={school.twitterLink} target="_blank">
                                  <img src={twitter} alt="" />
                                </a>
                              )}
                              {school.youtubeLink && school.youtubeLink != "- "&& (
                                <a href={school.youtubeLink} target="_blank">
                                  <img src={youtube} alt="" />
                                </a>
                              )}
                            </div>
                            <div class="academie-content-bottom-btn university-card-btns">
                              <a
                                href={school.website}
                                target="_blank"
                                class="btn"
                              >
                                Visiter le site
                              </a>
                              <Link
                                to={{
                                  pathname: `/etablissements/${slugify(
                                    school?.publicId
                                  )}/apply`,
                                  state: {
                                    code: school.publicId,
                                    isPublic: school.isPublic,
                                    name: school.name,
                                  },
                                }}
                                className="btn"
                              >
                                Je candidate
                              </Link>

                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="information">
                        <div class="row">
                          <div class="col-lg-3">
                            <div class="information-box">
                              <img src={date} alt="" />
                              <div class="information-content">
                                <p>April 20, 2024</p>
                                <span>Date de la prochaine rentrée</span>
                              </div>
                            </div>
                          </div>
                          <div class="col-lg-3">
                            <div class="information-box">
                              <img src={person} alt="" />
                              <div class="information-content">
                                {/* <p>In person</p> */}
                                <p>{school.teachingMode}</p>
                                <span>Formats d'apprentissage</span>
                              </div>
                            </div>
                          </div>
                          <div class="col-lg-3">
                            <div class="information-box">
                              <img src={clock} alt="" />
                              <div class="information-content">
                                <p>{school.formationRhythm}</p>
                                <span>Rythmes d'enseignemen</span>
                              </div>
                            </div>
                          </div>
                          <div class="col-lg-3">
                            <div class="information-box">
                              <img src={lang} alt="" />
                              <div class="information-content">
                                <p>{school.language}</p>
                                <span>Langue d'enseignement</span>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </section>
                ) : (
                  <></>
                )}

                <section class="counter-card">
                  <div class="row">
                    <div class="col-lg-4">
                      <div class="adress">
                        <div class="adress-content">
                          <h6>Adresse</h6>
                          <p>
                            {school
                              ? school.address
                              : "BPV 158 Abidjan, Abidjan, Costa do Marfim"}
                          </p>
                        </div>
                        <Maper
                          icon={mkSchool}
                          items={{ coordinates: school.coordinates }}
                          redirectLink="/schools"
                          zIndex={zIndex}
                          key={mkSchool}
                          size="300"
                          className="school-mapper"
                        />

                        {/* <Maper items={{ coordinates: school.coordinates }} size="300" icon={mkSchool} /> */}
                        {/* <img src="./assest/images/map.jpg" alt="" /> */}
                      </div>
                    </div>
                    <div class="col-lg-8">
                      <div class="counter-card-box">
                        <div class="counter-card-box-inner">
                          <div class="row">
                            <div class="col-lg-3">
                              <img src={icon1} alt="" />
                              {school ? (
                                school.top20Africa ? (
                                  <h6>
                                    ACE TOP
                                    <span>20</span>
                                  </h6>
                                ) : school.top10Africa ? (
                                  <h6>
                                    ACE TOP
                                    <span>10</span>
                                  </h6>
                                ) : school.top100Africa ? (
                                  <h6>
                                    ACE TOP
                                    <span>100</span>
                                  </h6>
                                ) : (
                                  <h6>
                                    ACE TOP
                                    <span>00</span>
                                  </h6>
                                )
                              ) : (
                                <h6>
                                  ACE TOP
                                  <span>00</span>
                                </h6>
                              )}
                              <p>Institution en Afrique</p>
                            </div>
                            <div class="col-lg-3">
                              <img src={icon2} alt="" />
                              <h6>
                                <span>00</span>
                              </h6>
                              <p>Nombre de Campus</p>
                            </div>
                            <div class="col-lg-3">
                              <img src={icon3} alt="" />
                              <h6>
                                <span>000</span>
                              </h6>
                              <p>Etudiants & alumni</p>
                            </div>
                            <div class="col-lg-3">
                              <img src={icon4} alt="" />
                              <h6>
                                <span>00</span>
                              </h6>
                              <p>Partenariats internationaux</p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </section>

                <section class="description">
                  <div class="row">
                    <div class="col-lg-12">
                      <div class="accordion" id="accordionExample">
                        <div class="accordion-item">
                          <h2 class="accordion-header" id="headingOne">
                            <button
                              class="accordion-button"
                              type="button"
                              data-bs-toggle="collapse"
                              data-bs-target="#collapseOne"
                              aria-expanded="true"
                              aria-controls="collapseOne"
                            >
                              Description du programme
                            </button>
                          </h2>
                          <div
                            id="collapseOne"
                            class="accordion-collapse collapse show"
                            aria-labelledby="headingOne"
                            data-bs-parent="#accordionExample"
                          >
                            <div class="accordion-body">
                              Lorem ipsum dolor sit amet, consectetur adipiscing
                              elit.
                            </div>
                          </div>
                        </div>
                        <div class="accordion-item">
                          <h2 class="accordion-header" id="headingTwo">
                            <button
                              class="accordion-button collapsed"
                              type="button"
                              data-bs-toggle="collapse"
                              data-bs-target="#collapseTwo"
                              aria-expanded="false"
                              aria-controls="collapseTwo"
                            >
                              Facilités et service
                            </button>
                          </h2>
                          <div
                            id="collapseTwo"
                            class="accordion-collapse collapse"
                            aria-labelledby="headingTwo"
                            data-bs-parent="#accordionExample"
                          >
                            <div class="accordion-body">
                              Quisque sapien augue, ornare id leo a, tristique
                              elementum justo.
                            </div>
                          </div>
                        </div>
                        <div class="accordion-item">
                          <h2 class="accordion-header" id="headingThree">
                            <button
                              class="accordion-button collapsed"
                              type="button"
                              data-bs-toggle="collapse"
                              data-bs-target="#collapseThree"
                              aria-expanded="false"
                              aria-controls="collapseThree"
                            >
                              Vie étudiante et logement
                            </button>
                          </h2>
                          <div
                            id="collapseThree"
                            class="accordion-collapse collapse"
                            aria-labelledby="headingThree"
                            data-bs-parent="#accordionExample"
                          >
                            <div class="accordion-body">
                              Praesent nec ipsum scelerisque dui condimentum
                              pellentesque eu at lectus.
                            </div>
                          </div>
                        </div>
                        <div class="accordion-item">
                          <h2 class="accordion-header" id="headingFour">
                            <button
                              class="accordion-button collapsed"
                              type="button"
                              data-bs-toggle="collapse"
                              data-bs-target="#collapseFour"
                              aria-expanded="false"
                              aria-controls="collapseFour"
                            >
                              Soutien à l’insertion professionnelle
                            </button>
                          </h2>
                          <div
                            id="collapseFour"
                            class="accordion-collapse collapse"
                            aria-labelledby="headingFour"
                            data-bs-parent="#accordionExample"
                          >
                            <div class="accordion-body">
                              Praesent nec ipsum scelerisque dui condimentum
                              pellentesque eu at lectus.
                            </div>
                          </div>
                        </div>
                        <div class="accordion-item">
                          <h2 class="accordion-header" id="headingFive">
                            <button
                              class="accordion-button collapsed"
                              type="button"
                              data-bs-toggle="collapse"
                              data-bs-target="#collapseFive"
                              aria-expanded="false"
                              aria-controls="headingFive"
                            >
                              Partenaires académiques
                            </button>
                          </h2>
                          <div
                            id="collapseFive"
                            class="accordion-collapse collapse"
                            aria-labelledby="headingFive"
                            data-bs-parent="#accordionExample"
                          >
                            <div class="accordion-body">
                              Praesent nec ipsum scelerisque dui condimentum
                              pellentesque eu at lectus.
                            </div>
                          </div>
                        </div>
                        <div class="accordion-item">
                          <h2 class="accordion-header" id="headingSix">
                            <button
                              class="accordion-button collapsed"
                              type="button"
                              data-bs-toggle="collapse"
                              data-bs-target="#collapseSix"
                              aria-expanded="false"
                              aria-controls="collapseSix"
                            >
                              Bourse(s) et financement des étude
                            </button>
                          </h2>
                          <div
                            id="collapseSix"
                            class="accordion-collapse collapse"
                            aria-labelledby="headingSix"
                            data-bs-parent="#accordionExample"
                          >
                            <div class="accordion-body">
                              Praesent nec ipsum scelerisque dui condimentum
                              pellentesque eu at lectus.
                            </div>
                          </div>
                        </div>
                        <div class="accordion-item">
                          <h2 class="accordion-header" id="headingSeven">
                            <button
                              class="accordion-button collapsed"
                              type="button"
                              data-bs-toggle="collapse"
                              data-bs-target="#collapseSeven"
                              aria-expanded="false"
                              aria-controls="collapseSeven"
                            >
                              Visa et immigration
                            </button>
                          </h2>
                          <div
                            id="collapseSeven"
                            class="accordion-collapse collapse"
                            aria-labelledby="headingSeven"
                            data-bs-parent="#accordionExample"
                          >
                            <div class="accordion-body">
                              Praesent nec ipsum scelerisque dui condimentum
                              pellentesque eu at lectus.
                            </div>
                          </div>
                        </div>
                        <div class="accordion-item">
                          <h2 class="accordion-header" id="headingEight">
                            <button
                              class="accordion-button collapsed"
                              type="button"
                              data-bs-toggle="collapse"
                              data-bs-target="#collapseEight"
                              aria-expanded="false"
                              aria-controls="collapseEight"
                            >
                              Contacter Académia Régionale des Sciences et
                              Techniques de la Mer
                            </button>
                          </h2>
                          <div
                            id="collapseEight"
                            class="accordion-collapse collapse"
                            aria-labelledby="headingEight"
                            data-bs-parent="#accordionExample"
                          >
                            <div class="accordion-body">
                              Praesent nec ipsum scelerisque dui condimentum
                              pellentesque eu at lectus.
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </section>

                <section class="tab-section">
                  <h2> Formations</h2>
                  {school && formationFilter ? (
                    <div className="d-flex">
                      {formationFilter.map((ele, index) => (
                        <div
                          key={`ex1${index}`}
                          className="nav nav-tabs flex-grow-1"
                          id={`ex1${index}`}
                          role="tablist"
                        >
                          <a
                            className={`nav-link ${index === 0 ? "active" : ""
                              }`}
                            id={`ex1${index}`}
                            data-bs-toggle="tab"
                            href={`#ex3-tabs-${index}`}
                            role="tab"
                            aria-controls={`ex3-tabs-${index}`}
                            aria-selected={index === 0 ? "true" : "false"}
                            onClick={() =>
                              this.handleTabClick(ele.formationLevel)
                            }
                          >
                            {ele.formationLevel}
                          </a>
                        </div>
                      ))}
                    </div>
                  ) : (
                    <></>
                  )}
                  <div className="tab-content" id="ex2-content">
                    <div className="tab-box-top">
                      <div class="row">
                        {school &&
                          formations.map((formation, index) => (
                            <div
                              key={index} // Make sure to provide a unique key for each mapped element
                              className="tab-pane col-lg-4 fade show active"
                              id={`ex3-tabs-${index + 1}`}
                              role="tabpanel"
                              aria-labelledby={`ex3-tab-${index + 1}`}
                            >
                              <div class="tab-box-content">
                                <div class="tab-box-content-div">
                                  <div class="tab-box-top">
                                    <div class="tab-box-left">
                                      <p>bts</p>
                                    </div>
                                    <div class="tab-box-right">
                                      <ul>
                                        <li>
                                          <a href="#">
                                            <img src={share} alt="" />
                                          </a>
                                        </li>
                                        <li>
                                          <a href="#">
                                            <img src={like} alt="" />
                                          </a>
                                        </li>
                                      </ul>
                                    </div>
                                  </div>
                                  <h6>{formation.name}</h6>
                                  <ul class="start-img-div">
                                    <Rate
                                      defaultValue={
                                        formation.noteValue
                                          ? parseFloat(formation.noteValue)
                                          : parseFloat(0)
                                      }
                                      allowClear={false}
                                      allowHalf
                                    />
                                  </ul>
                                  <p>Licence pro. en Génie Civil</p>
                                  <span>
                                    <img src={tick} alt="" />
                                    Reconnu par l’État
                                  </span>
                                </div>
                                <div class="tab-box-bottom">
                                  <ul>
                                    <li>
                                      <a href="#">
                                        <img
                                          src="./assest/images/lock.svg"
                                          alt=""
                                          class="lock-img"
                                        />
                                        10 avril 2021
                                      </a>
                                    </li>
                                    <li>
                                      <Link
                                        to={{
                                          pathname: `/formations/${slugify(
                                            formation.name
                                          )}`,
                                          state: {
                                            formationCode: formation.publicId,
                                            formationName: formation.name,
                                          },
                                        }}
                                      >
                                        <div className="formationBottomSecondFieldText">
                                          Voir plus{" "}
                                          <i className="bx bx-right-arrow-alt"></i>
                                        </div>
                                      </Link>
                                      {/* <a href="#">
                                      Voir plus
                                      <img
                                        src="./assest/images/errow.svg"
                                        alt=""
                                        class="errow-img"
                                      />
                                    </a> */}
                                    </li>
                                  </ul>
                                </div>
                              </div>
                            </div>
                          ))}
                      </div>
                    </div>
                  </div>
                  <div class="secoundary-btn-div">
                    <a
                      href={school.website}
                      target="_blank"
                      className="btn secoundary-btn"
                    >
                      Visiter le site
                    </a>
                    {/* <a href="#" class="btn secoundary-btn">
                      Visiter le site
                    </a> */}
                  </div>
                </section>

                <section class="Commentaires-section">
                  <div class="Commentaires-section-div">
                    <div class="row">
                      <div class="col-lg-3">
                        <div class="Commentaires-section-left">
                          <h2>5,0</h2>
                          <ul class="start-img-div">
                            <li>
                              <img src={StarImage} alt="" />
                            </li>
                            <li>
                              <img src={StarImage} alt="" />
                            </li>
                            <li>
                              <img src={StarImage} alt="" />
                            </li>
                            <li>
                              <img src={StarImage} alt="" />
                            </li>
                            <li>
                              <img src={StarImage} alt="" />
                            </li>
                          </ul>
                          <p>(40 évaluations)</p>
                        </div>
                      </div>
                      <div class="col-lg-9">
                        <div class="Commentaires-par">
                          <p>Commentaires récents</p>
                        </div>
                        {school && school.comments ? (
                          <div className="row">
                            {school.comments.map((comment, index) => (
                              <div className="col-lg-6" key={index}>
                                <div className="Commentaires-box">
                                  <div className="Commentaires-box-main">
                                    <div className="Commentaires-top-div">
                                      {/* <img src={vector} alt="" /> */}
                                      <div className="flex items-center justify-center h-8 w-8 rounded-full text-white bg-[#005073]">
                                        {"Amanda" ? "Amanda".charAt(0).toUpperCase() : ''}
                                      </div>
                                      <h6>Amanda</h6>{" "}
                                      {/* Use actual user name from your comment object */}
                                    </div>
                                    <p className="line-clamp-3">{comment.content}</p>
                                  </div>
                                  <div className="Commentaires-box-bottom">
                                    <ul>
                                      <li>5,0</li>{" "}
                                      {/* Assuming createdAt is the date property */}
                                      <li>
                                        {moment(comment.createdAt).format(
                                          "D MMM YY"
                                        )}
                                      </li>
                                    </ul>
                                  </div>
                                </div>
                              </div>
                            ))}
                          </div>
                        ) : (
                          <></>
                        )}

                        <div class="Commentaires-link">
                          <a href="#">Tout voir</a>
                        </div>
                      </div>
                    </div>
                    <div class="Commentaires-bottom-content">
                      <h6>Que pensez-vous de l'université?</h6>
                      <a href="#" class="btn">
                        Laisser un commentaire
                      </a>
                    </div>
                  </div>
                </section>

                <section class="ace-card-section">
                  <h2>
                    D’autres établissements qui pourraient vous intéresser
                  </h2>
                  {school && otherSchools ? (
                    <div className="row">
                      {otherSchools?.map((ele, index) => (
                        <div className="col-lg-6" key={index}>
                          <Link
                            to={{
                              pathname: `/etablissements/${slugify(ele.name)}`,
                              state: {
                                code: ele.publicId,
                                isPublic: ele.isPublic,
                                name: ele.name,
                              },
                            }}
                          >
                            <div className="ace-card-box">
                              <div className="ace-card-content">
                                <div className="ace-card-logo">
                                  <img src={uniogo} alt="" />
                                </div>
                                <div className="ace-card-text">
                                  <div className="ace-card-text-left">
                                    {/* <h6>Escola(ARSTM)</h6> */}
                                    <h6>{ele.name}</h6>
                                    <div class="top-title">
                                      <ul class="start-img-div">
                                        <Rate
                                          defaultValue={
                                            ele.noteValue
                                              ? parseFloat(ele.noteValue)
                                              : parseFloat(0)
                                          }
                                          allowClear={false}
                                          allowHalf
                                        />
                                      </ul>
                                      <p>
                                        Lomé •{" "}
                                        <span>
                                          Togo{" "}
                                          <a href="">
                                            <img src={togo} alt="" />
                                          </a>
                                        </span>
                                      </p>
                                    </div>
                                    <span>
                                      <img src={tick} alt="" />
                                      Reconnu par l’État
                                    </span>
                                  </div>
                                  <div className="ace-card-text-right">
                                    <div class="opportunit-icon-div">
                                      <div class="opportunit-icon-div-top">
                                        <a href="">
                                          <img src={share} alt="" />
                                        </a>
                                      </div>
                                      <div class="opportunit-icon-div-top">
                                        <a href="">
                                          <img src={like} alt="" />
                                        </a>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>

                              <img src={schoolBackgorund} alt="" />
                            </div>
                          </Link>
                        </div>
                      ))}
                    </div>
                  ) : (
                    <></>
                  )}
                </section>
              </div>
            </>
          ) : (
            <></>
          )}
        </>
      </React.Fragment>
    );
  }
}
School.propTypes = {
  school: PropTypes.object,
  sliders: PropTypes.array,
  onSetSchool: PropTypes.func,
  isPreloader: PropTypes.bool,
  tokenFailed: PropTypes.bool,
  tokenRetrieved: PropTypes.bool,
  onAppTokenAsked: PropTypes.func,
  onAppTokenRetrieved: PropTypes.func,
  onPreloaderToggled: PropTypes.func,
};
const mapStateToProps = (state) => ({
  school: state.school,
  schools: state.schools,
  sliders: state.sliders,
  tokenRetrieved: state.tokenRetrieved,
  tokenFailed: state.tokenFailed,
  isPreloader: state.isPreloader,
});
const mapDispatchToProps = (dispatch) => ({
  onSetSchool: (data) => dispatch(setSchool(data)),
  onAppTokenAsked: (data) => dispatch(setAppTokenAsked(data)),
  onAppTokenRetrieved: (data) => dispatch(setAppTokenRetrieved(data)),
  onPreloaderToggled: (preload, message) =>
    dispatch(togglePreloader(preload, message)),
});

export default connect(mapStateToProps, mapDispatchToProps)(School);
